import { Field } from 'redux-form'

/**
 * Handles getting credit_card_id from an instance of SelectPaymentMethod
 * @param paymentMethodRef - React Ref of the SelectPaymentMethodInstance
 * @returns Promise that resolves with credit_card_id
 */
export const handlePaymentMethod = (
  paymentMethodRef: React.RefObject<Field>
): Promise<string> | null => {
  if (!paymentMethodRef.current) return null
  return (
    paymentMethodRef.current
      .getRenderedComponent()
      // @ts-ignore
      .getCreditCardId()
  )
}
